import React, { useEffect, useRef } from 'react';
import { Backdrop } from '@material-ui/core';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessageWrappedInSpan } from '../../misc';

const StartHereOverlay = ({ open, onClick }) => {
  const buttonRef = useRef();

  useEffect(() => {
    if (open && buttonRef.current) {
      buttonRef.current.focus();
    }
  }, [open]);

  if (!open) return null;

  return (
    <Backdrop
      open={open}
      style={{
        position: 'absolute',
        zIndex: 2,
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        backdropFilter: 'blur(2px) grayscale(0.5)',
      }}
      aria-hidden="false"
      aria-modal="true"
      role="dialog"
    >
      <button
        ref={buttonRef}
        type="button"
        tabIndex={0}
        className={classNames('primary')}
        style={{
          zIndex: 3,
          boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
        }}
        onClick={onClick}
        aria-label="Start here to begin"
      >
        <FormattedMessageWrappedInSpan
          id="startHereOverlay.startHereButton"
          defaultMessage="Start here"
        />
      </button>
    </Backdrop>
  );
};

StartHereOverlay.propTypes = {
  open: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export { StartHereOverlay };
